import { VuexModule, Mutation, Action, Module } from 'vuex-module-decorators'
import ApiService from '@/services/apiService'
import UserAuthModel from '@/models/user/userAuthModel'
import UserTokenRefreshModel from '@/models/user/userTokenRefreshModel'
import UserTokenModel from '@/models/user/userTokenModel'
import Store from '@/store/index'
// import AuthorisationService from '@/services/authService'
import apiService from '@/services/apiService'

enum ExpertExtensionPermissions {
  None = 0,
  Access = 1,
  Write = 2,
  Admin = 4
}

@Module({ dynamic: true, store: Store, name: 'user', namespaced: true })
export default class UserModule extends VuexModule {
  private user: UserTokenModel = new UserTokenModel()

  @Mutation
  public setUserData(data: UserTokenModel): void {
    if (data) {
      this.user = new UserTokenModel(data)
      localStorage.setItem('user', JSON.stringify(data))
      ApiService.setUserToken(data.accessToken)
    }
  }

  @Mutation
  public clearUserData(): void {
    localStorage.removeItem('user')
    localStorage.removeItem('extension')
    location.reload()
  }

  @Action({ rawError: true, commit: 'setUserData' })
  public async login(credentials: UserAuthModel): Promise<UserTokenModel> {
    return await ApiService.postLogin(credentials)
  }

  @Action({ commit: 'clearUserData' })
  public logout(): void {}

  @Action
  public async refreshToken(
    refreshToken: UserTokenRefreshModel
  ): Promise<UserTokenModel> {
    try {
      const response = await apiService.refreshToken(refreshToken)
      this.context.commit('setUserData', response)
      return response
    } catch {
      this.context.commit('clearUserData')
      return new UserTokenModel()
    }
  }

  get loggedIn(): boolean {
    return !!this.user.accessToken
  }

  get isAdmin(): boolean {
    return true
  }

  get isSysAdmin(): boolean {
    return (
      (this.user.permissions.expertExtensions &
        ExpertExtensionPermissions.Admin) ===
      ExpertExtensionPermissions.Admin
    )
  }

  get isUser(): boolean {
    return true
  }

  get companyId(): string {
    return this.user.companyId
  }
}
